import { ExcelParsedProperties } from './channel-config';

export enum CHANNEL_VALIDATION {
    REQUIRED = 'required',
    NUMERIC = 'numeric',
    String = 'string',
    RANGE = 'range',
    RANGE_COMPARISON = 'range-comparison',
    VALUE_LENGTH = 'valuelength',
    VALUE_RANGE = 'valuerange',
    OUT_OF_RANGE = 'outofrange',
    NOT_INTEGER = 'notinteger',
    REMARK_LENGTH = 'remarklength',
    TOTAL_REMARK_LENGTH = 'totalRemarklength',
}

export const CHANNEL_RANGE_VALIDATION = {
    [ExcelParsedProperties.FixedDigit]: [1, 3],
    [ExcelParsedProperties.FcuNo]: [1, 8],
    [ExcelParsedProperties.InputDataFuInputAddressFuNo]: [0, 20],
    [ExcelParsedProperties.InputDataFuInputAddressSlotNo]: [1, 8],
    [ExcelParsedProperties.InputDataFuInputAddressPin]: [1, 64],
    [ExcelParsedProperties.InputDataFuInputAddressPinCount]: [0, 8],
    //TBD
    // [ExcelParsedProperties.InputDataMemoryInputAddressAddress]: [1, 8],
    // [ExcelParsedProperties.InputDataMemoryInputAddressMask]: [1, 8],
    [ExcelParsedProperties.InputDataMiscDigitalInputFilter]: [1, 100],
    [ExcelParsedProperties.InputDataMiscHysteresis]: [0, 10],

    [ExcelParsedProperties.OutputDataFuOutputAddressFuNo]: [0, 20],
    [ExcelParsedProperties.OutputDataFuOutputAddressSlotNo]: [1, 8],
    [ExcelParsedProperties.OutputDataFuOutputAddressPin]: [1, 64],
    [ExcelParsedProperties.OutputDataFuOutputAddressPinCount]: [0, 8],
    //TBD
    // [ExcelParsedProperties.OutputDataMemoryOutputAddressAddress]: [1, 8],
    // [ExcelParsedProperties.OutputDataMemoryOutputAddressMask]: [1, 8],
    [ExcelParsedProperties.OutputDataMiscSignalWidth]: [100, 10000],
    [ExcelParsedProperties.OutputDataMiscHysteresisForOpen]: [1, 100],
    [ExcelParsedProperties.OutputDataMiscHysteresisForClose]: [1, 100],

    [ExcelParsedProperties.DigitalAlarmSettingAlarmGroupNo]: [0, 24],
    [ExcelParsedProperties.DigitalAlarmSettingReposeGroup1No]: [0, 100],
    [ExcelParsedProperties.DigitalAlarmSettingReposeGroup2No]: [0, 100],
    [ExcelParsedProperties.DigitalAlarmSettingDelayTimer]: [0, 3600],

    [ExcelParsedProperties.MotorChannelSettingAlarmGroupNo]: [0, 24],
    [ExcelParsedProperties.MotorChannelSettingReposeGroup1No]: [0, 100],
    [ExcelParsedProperties.MotorChannelSettingReposeGroup2No]: [0, 100],
    [ExcelParsedProperties.MotorChannelSettingDelayTimer]: [0, 3600],

    [ExcelParsedProperties.AlarmSettingVeryHighAlarmGroupNo]: [0, 24],
    [ExcelParsedProperties.AlarmSettingVeryHighReposeGroup1No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingVeryHighReposeGroup2No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingVeryHighDelayTimer]: [0, 3600],

    [ExcelParsedProperties.AlarmSettingHighAlarmGroupNo]: [0, 24],
    [ExcelParsedProperties.AlarmSettingHighReposeGroup1No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingHighReposeGroup2No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingHighDelayTimer]: [0, 3600],

    [ExcelParsedProperties.AlarmSettingLowAlarmGroupNo]: [0, 24],
    [ExcelParsedProperties.AlarmSettingLowReposeGroup1No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingLowReposeGroup2No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingLowDelayTimer]: [0, 3600],

    [ExcelParsedProperties.AlarmSettingVeryLowAlarmGroupNo]: [0, 24],
    [ExcelParsedProperties.AlarmSettingVeryLowReposeGroup1No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingVeryLowReposeGroup2No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingVeryLowDelayTimer]: [0, 3600],

    [ExcelParsedProperties.AlarmSettingSensorFailAlarmGroupNo]: [0, 24],
    [ExcelParsedProperties.AlarmSettingSensorFailReposeGroup1No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingSensorFailReposeGroup2No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingSensorFailDelayTimer]: [0, 3600],

    [ExcelParsedProperties.AlarmSettingFeedbackErrorAlarmGroupNo]: [0, 24],
    [ExcelParsedProperties.AlarmSettingFeedbackErrorReposeGroup1No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingFeedbackErrorReposeGroup2No]: [0, 100],
    [ExcelParsedProperties.AlarmSettingFeedbackErrorDelayTimer]: [0, 3600],

    [ExcelParsedProperties.SystemAlarmSettingAlarmGroupNo]: [0, 24],
    [ExcelParsedProperties.SystemAlarmSettingReposeGroup1No]: [0, 100],
    [ExcelParsedProperties.SystemAlarmSettingReposeGroup2No]: [0, 100],
    [ExcelParsedProperties.SystemAlarmSettingDelayTimer]: [0, 3600],
};

export const CHANNEL_LENGTH_VALIDATION = {
    [ExcelParsedProperties.Tag]: [1, 10],
    [ExcelParsedProperties.Name]: [1, 50],
    [ExcelParsedProperties.MeasurementUnit]: [1, 8],
    [ExcelParsedProperties.MeasurableRangeMax]: [0, 9],
    [ExcelParsedProperties.MeasurableRangeMin]: [0, 9],
    [ExcelParsedProperties.NormalRangeMax]: [0, 9],
    [ExcelParsedProperties.NormalRangeMin]: [0, 9],
    [ExcelParsedProperties.DigitalAlarmSettingStatusStringContactOn]: [1, 10],
    [ExcelParsedProperties.DigitalAlarmSettingStatusStringContactOff]: [1, 10],
    [ExcelParsedProperties.AlarmSettingVeryHighStatusString]: [1, 10],
    [ExcelParsedProperties.AlarmSettingHighStatusString]: [1, 10],
    [ExcelParsedProperties.AlarmSettingLowStatusString]: [1, 10],
    [ExcelParsedProperties.AlarmSettingVeryLowStatusString]: [1, 10],
    [ExcelParsedProperties.MotorChannelSettingStopStatusString]: [1, 10],
    [ExcelParsedProperties.MotorChannelSettingStbyStatusString]: [1, 10],
    [ExcelParsedProperties.MotorChannelSettingRunStatusString1]: [1, 10],
    [ExcelParsedProperties.MotorChannelSettingRunStatusString2]: [1, 10],
    [ExcelParsedProperties.MotorChannelSettingRunStatusString3]: [1, 10],
    [ExcelParsedProperties.MotorChannelSettingRunStatusString4]: [1, 10],
    [ExcelParsedProperties.MotorChannelSettingRunStatusString5]: [1, 10],
    [ExcelParsedProperties.AlarmSettingSensorFailStatusString]: [1, 10],
    [ExcelParsedProperties.AlarmSettingFeedbackErrorStatusString]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString1]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString2]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString3]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString4]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString5]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString6]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString7]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString8]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString9]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString10]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString11]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString12]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString13]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString14]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString15]: [1, 10],
    [ExcelParsedProperties.SystemAlarmSettingStatusString16]: [1, 10],
    [ExcelParsedProperties.StandardNameId]: [0, 50],
    [ExcelParsedProperties.Remarks]: [0, 15],
};
